import formatMeetingTimeSpan from 'owa-timeformat/lib/utils/formatMeetingTimeSpan';
import MeetingMessage from 'owa-service/lib/contract/MeetingMessage';
import { CalendarEvent } from 'mini-calendar-event-types';
import { format } from 'owa-strings';
import { getOwaMiniCommonStrings } from 'owa-strings/owa-mini-common-strings';
import { selectStringForCount } from 'mini-common-utils/lib/utils/selectStringForCount';

/**
 * Given an item subtitle for that item if it was sent by organizer
 * @param item
 */
export const getRsvpUnitSubtitleForOrganizer = (
    item: CalendarEvent,
    originalMeetingMessage?: MeetingMessage
): string => {
    const strings = getOwaMiniCommonStrings();
    const { Start, End } = item;

    let subtitle: string;
    if (item.IsSeriesCancelled || (item.IsCancelled && item.isSeriesMaster?.())) {
        subtitle = strings.seriesCancelledEventDetailsSubtitle;
    } else if (item.isSeriesInstance?.() && item.IsCancelled) {
        subtitle = strings.instanceCancelledEventDetailsSubtitle;
    } else if (item.IsCancelled && !item.IsRecurring) {
        subtitle = strings.eventCancelledEventDetailsSubtitle;
    } else if (item.IsRecurring) {
        subtitle = formatMeetingTimeSpan(Start, End, item.Recurrence, true /** is short string */);
    } else {
        subtitle = format(
            selectStringForCount(
                item.ActualConflictingMeetingCount,
                strings.singleConflictEventDetailsInMessage,
                strings.dualConflictEventDetailsInMessage,
                strings.multipleConflictsEventDetailsInMessage,
                strings.noConflictsLabel,
                item.NextConflictingEvent?.Subject || strings.noSubjectText
            )
        );
    }

    return subtitle;
};
